import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center"
}: SectionHeadingProps) {
  const alignment = align === "center" ? "mx-auto items-center text-center" : "items-start text-left";
  return <div className={`mb-10 flex max-w-3xl flex-col ${alignment}`} data-id="element-187" data-mp="3k0oxz55spwd1">
      {eyebrow && <span className="mb-4 rounded-full border border-[#F5B83D]/30 bg-[#F5B83D]/10 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-[#FFD66B]" data-id="element-188" data-mp="blol3if4mu9w">
          {eyebrow}
        </span>}
      <h2 className="font-heading text-3xl font-black leading-[1.05] tracking-[-0.035em] text-[#FFFFFF] sm:text-4xl lg:text-5xl" style={{
      fontSize: "34px"
    }} data-id="element-189" data-mp="1u0wdp9yfrc4">{title}</h2>
      {subtitle && <p className="mt-4 max-w-2xl text-base leading-7 text-[#C7CED8] sm:text-lg" style={{
      fontSize: "13px"
    }} data-id="element-190" data-mp="ui6gc9t6pcaw">{subtitle}</p>}
      <div className={`mt-6 h-1 w-20 rounded-full bg-[linear-gradient(90deg,#C81724,#F5B83D)] ${align === "center" ? "mx-auto" : ""}`} data-id="element-191" data-mp="zb923vrpzhgj" />
    </div>;
}